<template>
    <dialog-template
        headerTitle="激活服务"
        :width="'400px'"
        :visible.sync="isShowDialog">
        <div class="activate-wrapper fx-v-center">
            <span>激活码：</span>
            <div class="ipt-wrapper">
                <el-input ref="elIpt" v-model="val" placeholder="请输入服务激活码" @input="handleIpt"/>
                <span class="tips error-tips" v-if="isError">{{ msg }}</span>
                <span class="tips success-tips" v-if="isSuccess">
                    可激活 <span>门店零售标准版_一年</span> 服务
                </span>
            </div>
        </div>
        <div slot="footer"
            class="fx-center">
            <el-button
                type="primary"
                size="medium"
                :disabled="!(isCanUse && val.length === 8)"
                @click="confirm">
                确认激活
            </el-button>
            <el-button
                type="default"
                size="medium"
                @click="close">
                取消
            </el-button>
        </div>
    </dialog-template>
</template>

<script lang='ts'>
import { createComponent, ref } from '@vue/composition-api'
import $fetch from '@/api'
import { openMessage } from '@/utils/system'
import { inputLimit } from '@/utils'

export default createComponent({
    setup(props, ctx) {
        const isCanUse = ref(false)
        const isShowDialog = ref(false)
        const isSuccess = ref(false)
        const isError = ref(false)
        const val = ref('')
        const msg = ref('')

        const iptLimit = inputLimit(/^[\d\w]{0,8}$/)
        let cb

        function open(options?: {
            callback?: () => void
        }) {
            const opts = Object.assign({
                callback: function() {}
            }, options)
            cb = opts.callback
            val.value = ''
            msg.value = ''
            isShowDialog.value = true
            isSuccess.value = false
            isError.value = false
            isCanUse.value = false
            ctx.root.$nextTick(() => {
                (ctx.refs.elIpt as any).focus()
            })
        }

        function close() {
            isShowDialog.value = false
        }

        function handleIpt() {
            iptLimit(val, 'value')
            if (val.value.length !== 8) {
                return
            }
            return check()
        }

        function check() {
            isError.value = false
            isSuccess.value = false
            return $fetch.post({
                url: '/valueaddedservices/checkactivecode',
                params: {
                    active_code: val.value
                }
            }).then(data => {
                console.log('检测结果', data)
                isCanUse.value = true
                isSuccess.value = true
            }).catch(e => {
                isCanUse.value = false
                isError.value = true
                msg.value = e.message || '激活失败'
            })
        }

        function confirm() {
            return $fetch.post({
                url: '/valueaddedservices/activateshop',
                params: {
                    active_code: val.value
                }
            }).then(data => {
                console.log('激活码返回结果', data)
                openMessage('success', '您已成功激活门店零售标准版_一年 服务')
                isShowDialog.value = false
                ctx.emit('close')
                cb()
            }).catch(e => {
                openMessage('error', e.message || '激活失败，请重试')
            })
        }

        return {
            isCanUse,
            isShowDialog,
            isSuccess,
            isError,
            val,
            msg,
            handleIpt,
            open,
            close,
            confirm,
            iptLimit
        }
    }
})
</script>

<style lang="scss" scoped>
.activate-wrapper {
    span {
        flex: none;
    }
}

.ipt-wrapper {
    position: relative;
    flex: 1;

    .tips {
        position: absolute;
        left: 0;
        top: 44px;
        font-size: 12px;

        &.error-tips {
            color: #FF2A2A;
        }

        &.success-tips {
            span {
                color: #009688;
            }
        }
    }
}

::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
    padding: 0 8px;

}

::v-deep .el-dialog .el-dialog__body {
    padding-bottom: 45px !important;
}
</style>
